// 公用js

class Common {
    goPage(url,context,query){
        context.$router.push(url)
    }
}

export default new Common()